export { segment } from "./segment";
export { googleTagManager, UserType } from "./googleTagManager";
export { HotjarScript } from "./HotjarScript";
